import { Link } from 'react-router-dom';

import type React from 'react';

export interface ConformidadeDeferTabProps {
  title: string;
  message: string;
  /** Rota interna para uma tela que já cobre o assunto (ex.: B6 Curadoria). */
  linkTo?: string;
  linkLabel?: string;
}

/**
 * Placeholder honest-defer das abas auxiliares do Centro de conformidade
 * (Bolhas de confidencialidade / Capacidade legal / Acessos anômalos). Sem dado
 * fake: estado claro de "em breve" + opcionalmente um link para a tela que já
 * existe (Capacidade legal → `/dpo/guardianship`). A aba forense de conflitos
 * de interesse (F1) é a entrega real desta tela; estas materializam em follow-up.
 */
export function ConformidadeDeferTab({
  title,
  message,
  linkTo,
  linkLabel,
}: ConformidadeDeferTabProps): React.JSX.Element {
  return (
    <div
      style={{
        background: 'var(--bg-surface)',
        border: '1px dashed var(--border-default)',
        borderRadius: 'var(--radius-md)',
        padding: 'var(--space-10) var(--space-6)',
        textAlign: 'center',
        color: 'var(--fg-3)',
        margin: 'var(--space-5)',
      }}
    >
      <div style={{ fontSize: 'var(--text-3xl)', marginBottom: 12 }} aria-hidden="true">
        🧭
      </div>
      <h2
        style={{
          fontSize: 'var(--text-base)',
          fontWeight: 'var(--fw-semibold)',
          color: 'var(--fg-1)',
          marginBottom: 8,
        }}
      >
        {title}
      </h2>
      <p style={{ maxWidth: 480, margin: '0 auto', fontSize: 'var(--text-sm)' }}>{message}</p>
      {linkTo !== undefined && (
        <div style={{ marginTop: 'var(--space-4)' }}>
          <Link to={linkTo} className="btn-ghost-mini">
            {linkLabel ?? 'Abrir'} →
          </Link>
        </div>
      )}
    </div>
  );
}
